import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import {User} from "../../../../models/User";
import {ApiService} from "../../../../services/api.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-update-user-credentials',
  templateUrl: './update-user-credentials.component.html',
})
export class UpdateUserCredentialsComponent implements OnInit, OnDestroy {

  @Input() user: User | null;
  passWordForm: FormGroup;
  emailForm: FormGroup;

  showChangeEmailForm: boolean = false;
  showChangePasswordForm: boolean = false;
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showPassword: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isLoading: boolean;
  private unsubscribe: Subscription[] = [];

  constructor(private cdr: ChangeDetectorRef, public api:ApiService, public fb:FormBuilder) {

    this.passWordForm = this.fb.group({
        new_password: ['', Validators.required],
        new_password_confirmation: ['', Validators.required]
    });

    this.emailForm = this.fb.group({
      email: [null, Validators.required]
    });

    if(this.user){
      this.emailForm.controls['email'].setValue(this.user.email);
    }

    const loadingSubscr = this.isLoading$
      .asObservable()
      .subscribe((res) => (this.isLoading = res));
    this.unsubscribe.push(loadingSubscr);
  }

  ngOnInit(): void {}

  toggleEmailForm(show: boolean) {
    this.showChangeEmailForm = show;
  }

  saveEmail() {
    if(this.user && this.emailForm.valid){
      this.isLoading$.next(true);
      this.api.apiPost('/admin/users/' + this.user.id + '/email', this.emailForm.value).then(() => {
        this.isLoading$.next(false);
        this.showChangeEmailForm = false;
        this.cdr.detectChanges();
      });
    }
  }

  togglePasswordForm(show: boolean) {
    this.showChangePasswordForm = show;
  }

  savePassword() {
    if(this.user && this.passWordForm.valid){
      this.isLoading$.next(true);
      this.api.apiPost('/admin/users/' + this.user.id + '/password', this.passWordForm.value).then(() => {
        this.isLoading$.next(false);
        this.showChangePasswordForm = false;
        this.cdr.detectChanges();
      });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  getPasswordType(){
    if(this.showPassword.value){
      return 'text';
    }else{
      return 'password';
    }
  }

  togglePassword(){
    if(this.showPassword.value){
      this.showPassword.next(false);
    }else{
      this.showPassword.next(true);
    }
  }


}
